(function() {
  'use strict';

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    setupReveal();
    setupHero();
    if (!reduce) setupParallax();
    setupPhoneMask();
    setupApplyLinks();
    scrollToSuccess();
  }

  // ===== Reveal =====
  function setupReveal() {
    const els = document.querySelectorAll('.bmj-rv');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(el => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(el => io.observe(el));
  }

  // ===== Hero =====
  function setupHero() {
    const hero = document.querySelector('.bmj-hero');
    if (!hero) return;
    requestAnimationFrame(() => setTimeout(() => hero.classList.add('in'), 100));
  }

  // ===== Parallax =====
  function setupParallax() {
    const layers = document.querySelectorAll('[data-parallax]');
    if (!layers.length) return;
    let ticking = false;
    function update() {
      layers.forEach(layer => {
        const scene = layer.closest('[data-parallax-scene]');
        if (!scene) return;
        const rect = scene.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const offset = (rect.top / window.innerHeight) * 60;
        layer.style.transform = `translateY(${offset}px)`;
      });
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // ===== Máscara telefone =====
  function setupPhoneMask() {
    const phone = document.getElementById('bmj-phone');
    if (!phone) return;
    phone.addEventListener('input', () => {
      let v = phone.value.replace(/\D/g, '').slice(0, 11);
      if (v.length > 6) phone.value = `(${v.slice(0,2)}) ${v.slice(2,7)}-${v.slice(7)}`;
      else if (v.length > 2) phone.value = `(${v.slice(0,2)}) ${v.slice(2)}`;
      else if (v.length > 0) phone.value = `(${v}`;
    });
  }

  // ===== "Candidatar-se" pré-seleciona a vaga no select =====
  function setupApplyLinks() {
    const select = document.querySelector('[data-apply-select]');
    document.querySelectorAll('[data-job-apply]').forEach(btn => {
      btn.addEventListener('click', () => {
        const title = btn.dataset.jobTitle;
        if (select && title) {
          // marca a opção correspondente
          Array.from(select.options).forEach(opt => {
            if (opt.value === title) select.value = title;
          });
        }
      });
    });
  }

  // ===== Rola até sucesso =====
  function scrollToSuccess() {
    const success = document.querySelector('[data-apply-success]');
    if (success) success.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();